import { render, staticRenderFns } from "./ContactPersonAutocomplete.vue?vue&type=template&id=dfa73d06&scoped=true&"
import script from "./ContactPersonAutocomplete.vue?vue&type=script&lang=js&"
export * from "./ContactPersonAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa73d06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VListItemContent,VListItemSubtitle,VListItemTitle})
